import { render, staticRenderFns } from "./download-centre.vue?vue&type=template&id=e16c434e&scoped=true"
import script from "./download-centre.vue?vue&type=script&lang=js"
export * from "./download-centre.vue?vue&type=script&lang=js"
import style0 from "./download-centre.vue?vue&type=style&index=0&id=e16c434e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16c434e",
  null
  
)

export default component.exports